export default {
  title: 'Leveringsadresse',
  buttons: {
    save: 'Gem',
  },
};
